import React from 'react';
import { useTranslations } from 'next-intl';
import Stepper from '@monofront/design-system/components/Stepper';
import useCheckoutSteps, { ICheckoutStep } from '@hooks/useCheckoutSteps';

const CheckoutStepper: React.FC<ICheckoutStep> = ({ currentStep }) => {
  const t = useTranslations('Checkout.Stepper');

  const steps = useCheckoutSteps();

  const currentStepIndex = steps.map(({ step }) => step).indexOf(currentStep);

  return (
    <>
      <Stepper>
        {steps.map(
          ({ Icon, titleTranslationKey, onClick, step, dataTestId }, index) => {
            const active = index <= currentStepIndex;
            const current = step === currentStep;
            const inactive = index > currentStepIndex;

            return (
              <button
                onClick={onClick}
                disabled={inactive}
                key={titleTranslationKey}
                className={`step ${inactive ? 'inactive' : ''}`}
                data-testid={dataTestId}
              >
                <Icon current={current} active={active} />
                <span className={`step-title ${current ? 'current' : ''}`}>
                  {t(titleTranslationKey)}
                </span>
              </button>
            );
          },
        )}
      </Stepper>
      <style jsx>{`
        .step {
          display: flex;
          flex-direction: column;
          align-items: center;
          border: transparent;
          background-color: transparent;
          padding: 1px;
        }

        .step-title {
          font-size: var(--font-size-1);
          font-weight: var(--font-weight-light);
          line-height: var(--font-size-1);
        }

        .current {
          line-height: var(--font-size-2);
          font-weight: var(--font-weight-base);
        }

        .inactive {
          opacity: 50%;
        }
      `}</style>
    </>
  );
};

export default CheckoutStepper;
